import React, { useEffect } from 'react'

const Chat = ({ chat }) => {
    useEffect(() => {
        const scrolldiv = document.getElementById('chatbody_scroll');
        scrolldiv.scrollTop = scrolldiv.scrollHeight;
    }, [chat])

    // console.log(chat);
    return (
        <>
            {chat.question &&
                <div className="d-flex justify-content-start align-items-center mb-lg-2 mb-md-2 mb-2">
                    <div className="user_profile text-center me-3">
                        <i className="fas fa-robot"></i>
                    </div>
                    <div>
                        {typeof chat.question === 'string' &&
                            <div className="user_chatbox bg-white p-3 p-md-3 rounded-4 mb-2">
                                {chat.question}
                            </div>
                        }
                        {typeof chat.question === 'object' && chat.question.map((msg, i) => (
                            <div key={i.toString()} className="user_chatbox bg-white p-3 p-md-3 rounded-4 mb-2">
                                {msg}
                            </div>
                        ))}
                    </div>
                </div>
            }
            {chat.answer &&
                <div className="d-flex justify-content-end align-items-end mb-lg-2 mb-md-2 mb-2">
                    <div>
                        {typeof chat.answer === 'string' &&
                            <div className="user_chatbox bg-white p-3 rounded-4 mb-2">
                                {chat.answer}
                            </div>
                        }
                        {typeof chat.answer === 'object' && chat.answer.map((msg, i) => (
                            <div key={i.toString()} className="user_chatbox bg-white p-3 rounded-4 mb-2">
                                {msg}
                            </div>
                        ))}
                    </div>

                    <div className="user_profile text-center ms-3">
                        <i className="fas fa-user"></i>
                    </div>
                </div>
            }
        </>
    )
}

export default Chat


